<template>
  <div v-on="hoverHandlers">
    <slot :is-hover="isHover" />
  </div>
</template>

<script>
import hoverable from '../mixins/hoverable';

export default {
  name: 'BaseHover',
  mixins: [hoverable],
};
</script>
